import { Features } from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { BookingsAPI } from '../../api/BookingsApi';
import { ServiceListContext } from '../../context/createServiceListContext';
import { enrichServices } from '../../utils/services/services';
import { WidgetViewModel } from '../../viewModel/viewModel';

export type ClearSearchServicesAction = () => Promise<void>;

export const createClearSearchServicesAction =
  ({
    widgetViewModel,
    bookingsApi,
    flowAPI,
    setProps,
    serviceListContext,
    activeFeatures,
    isPricingPlanInstalled,
  }: {
    widgetViewModel: WidgetViewModel;
    bookingsApi: BookingsAPI;
    flowAPI: ControllerFlowAPI;
    setProps: Function;
    serviceListContext: ServiceListContext;
    activeFeatures: Features;
    isPricingPlanInstalled: boolean;
  }): ClearSearchServicesAction =>
  async () => {
    try {
      const queryServicesResponse = await bookingsApi.queryServices();
      const enrichedResults = await enrichServices({
        flowAPI,
        activeFeatures,
        isPricingPlanInstalled,
        services: queryServicesResponse.services || [],
        isAnywhereFlow: serviceListContext.isAnywhereFlow,
      });
      widgetViewModel.services = enrichedResults;
      setProps({ widgetViewModel: { ...widgetViewModel } });
    } catch (error) {
      console.error('clearSearchServices failed:', error);
    }
  };
